import { BLACK_HEX, WHITE_HEX } from '../../modules/theme/colors';

const contrastYIQ = (currColor) => {
  let color = currColor.slice(1);
  if (color.length === 3) {
    color = `${color[0]}${color[0]}${color[1]}${color[1]}${color[2]}${color[2]}`;
  }

  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

  return (yiq >= 150) ? BLACK_HEX : WHITE_HEX;
};

export default contrastYIQ;
